import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { getCircleButtonClass } from './CircleButton';
import { getClassName } from '../../../utils/ui/classes';
import CalenderIcon from '../icons/CalendarIcon';
import sizes from './sizes';

const DateIconButton = ({ value, disabled, onClick, id, className, size, dataTestId }) => {
  function handleClick(e) {
    e.preventDefault();
    onClick();
  }

  const { t } = useTranslation();

  return (
    (<button
      data-testid={dataTestId}
      id={id}
      className={getClassName(className)}
      disabled={disabled}
      onClick={handleClick}
      title={t('CLICK_TO_CHANGE_DATE')}>
      <div data-testid="div-e0e56cd4" className="flex items-center">
        <div
          data-testid="div-1b8d0664"
          className={getCircleButtonClass({
            color: 'green',
            size,
            disabled,
            className: 'mr-1',
          })}>
          <CalenderIcon className="w-5 h-5" />
        </div>
        {value && (
          <span
            data-testid="span-16fd1778"
            className="text-sm text-grey-darker group-hover:text-grey-darkest">
            {value}
          </span>
        )}
      </div>
    </button>)
  );
};

DateIconButton.propTypes = {
  id: PropTypes.string,
  size: PropTypes.oneOf(Object.values(sizes)),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

DateIconButton.defaultProps = {
  size: sizes.small,
  disabled: false,
};

export default DateIconButton;
